import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from '../../services/storage/storage.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-welcome',
  standalone: true,
  imports: [],
  templateUrl: './welcome.component.html',
  styleUrl: './welcome.component.scss'
})
export class WelcomeComponent {

  router: Router = inject(Router);
  storageService: StorageService = inject(StorageService);

  navigateToConnect() {
    const userId = this.getuserId();
    this.router.navigate([`/connect/${userId}/${environment.default.businessId}`]);
  }

  getuserId() {
    const userId = this.storageService.get('userId');
    if (!userId) {
     const randomString = Math.random().toString(36).substring(2, 15);
     this.storageService.set('userId', randomString);
     return randomString;
    }
    return userId;
  }

}
